import {Component, computed, inject, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {Select} from 'primeng/select';
import {Tooltip} from 'primeng/tooltip';
import {TenderPhaseDetailsResponse, TenderSelection} from '@frontend/shared-api';
import {BaseParticipatingTool, PhaseInvitationConfig} from '../../../invitation-table.types';
import {SELECTION_OPTION_KEYS, SelectionOption} from './participating-tool-selection.types';

@Component({
  selector: 'app-participating-tool-selection',
  imports: [FormsModule, TranslocoPipe, Select, Tooltip],
  templateUrl: './participating-tool-selection.component.html',
})
export class ParticipatingToolSelectionComponent {
  private readonly transloco = inject(TranslocoService);

  readonly item = input.required<BaseParticipatingTool>();
  readonly phaseConfig =
    input.required<Pick<PhaseInvitationConfig, 'prerequisiteChecker' | 'stepLockedFn'>>();
  readonly currentPhase = input.required<TenderPhaseDetailsResponse | null>();

  readonly selectionChange = output<TenderSelection | null>();

  protected readonly options = computed((): SelectionOption[] =>
    SELECTION_OPTION_KEYS.map((option) => ({
      label: this.transloco.translate(option.labelKey),
      value: option.value,
    })),
  );

  protected readonly value = computed(() => this.item().selection ?? null);
  protected readonly selectionLocked = computed(() => (this.item().status ?? null) !== null);
  protected readonly stepLocked = computed(() => this.phaseConfig().stepLockedFn());
  protected readonly prerequisiteMet = computed(() => this.phaseConfig().prerequisiteChecker());
  protected readonly subPhaseFinal = computed(() => !!this.currentPhase()?.finalSubPhase);
  protected readonly isReadOnly = computed(
    () =>
      this.selectionLocked() ||
      !this.prerequisiteMet() ||
      this.stepLocked() ||
      this.subPhaseFinal(),
  );
  protected readonly tooltipKey = computed(() => {
    if (this.stepLocked()) {
      return 'project.steps.stepLocked';
    }
    return this.selectionLocked() ? 'project.steps.invitationList.selectionLocked' : '';
  });
}
